import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const COMMUNITY = {
  ROOT: `${PRIVATE_ROOT}/community`,
}
